import { render, staticRenderFns } from "./LightReflectionViz.vue?vue&type=template&id=d3c938f4&scoped=true"
import script from "./LightReflectionViz.vue?vue&type=script&lang=js"
export * from "./LightReflectionViz.vue?vue&type=script&lang=js"
import style0 from "./LightReflectionViz.vue?vue&type=style&index=0&id=d3c938f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c938f4",
  null
  
)

export default component.exports